import OutLineMobileTen from '@assets/icons/outline-mobile-ten.svg'
import { Icon } from './Icon'

export const OutLineMobileTenIcon = Icon(OutLineMobileTen)
